import { render, staticRenderFns } from "./template-measurement-edit.vue?vue&type=template&id=31a8dcf4"
import script from "./template-measurement-edit.vue?vue&type=script&lang=js"
export * from "./template-measurement-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports